import Skeleton from '../ui/Skeleton';

/** Loading placeholder matching ZOE answer card layout (profit-specific sections). */
export default function ProfitAnswerSkeleton() {
  return (
    <div className="space-y-3" aria-busy="true" aria-label="Loading answer">
      <div className="bg-card/40 rounded-xl border border-border/50 p-4 space-y-3">
        <div>
          <div className="text-sm font-medium text-muted-foreground mb-1">Summary</div>
          <Skeleton className="h-5 w-3/4" />
          <Skeleton className="h-5 w-1/2 mt-2" />
        </div>

        <div className="bg-background/30 border border-border/40 rounded-lg p-3">
          <div className="text-sm font-medium text-muted-foreground mb-1">Key findings</div>
          <div className="space-y-2 mt-2">
            <Skeleton className="h-4 w-92%" />
            <Skeleton className="h-4 w-86%" />
            <Skeleton className="h-4 w-72%" />
          </div>
        </div>

        <div className="bg-background/30 border border-border/40 rounded-lg p-3">
          <div className="text-sm font-medium text-muted-foreground mb-1">Recommended actions</div>
          <div className="space-y-2 mt-2">
            <Skeleton className="h-4 w-88%" />
            <Skeleton className="h-4 w-64%" />
          </div>
        </div>
      </div>
    </div>
  );
}
